'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Illustration = require('./Illustration');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Illustration).default;
  }
});
Object.defineProperty(exports, 'IMAGES', {
  enumerable: true,
  get: function get() {
    return _Illustration.IMAGES;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }